export default __webpack_public_path__ + "static/business-bg-10ea7087c99eda07e09f4a9914d75577.svg";